import UserSendPassButton from "./user-send-pass-button";


const UserActionItems = {
    SendPass: UserSendPassButton,
};

export default UserActionItems;